import React, { Suspense, useState, useEffect } from "react";

type SuspenseWithDelayProps = {
  children: React.ReactNode;
  fallback: React.ReactNode;
  delay?: number;
};
/**
 * SuspenseWithDelay Component
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - The components to render within Suspense.
 * @param {React.ReactNode} props.fallback - The fallback UI to display.
 * @param {number} props.delay - Delay in milliseconds before showing the fallback.
 * @returns {React.ReactElement}
 */
function SuspenseWithDelay({
  children,
  fallback,
  delay = 1000
}: SuspenseWithDelayProps) {
  const [showFallback, setShowFallback] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowFallback(true);
    }, delay);

    return () => clearTimeout(timer);
  }, [delay]);

  return (
    <Suspense fallback={showFallback ? fallback : null}>{children}</Suspense>
  );
}

export default SuspenseWithDelay;
